var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeadMini = function SvgHeadMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_311_1002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 16.5C13.866 16.5 17 15.4412 17 14.1351C17 12.829 13.866 11.7702 10 11.7702C6.13401 11.7702 3 12.829 3 14.1351C3 15.4412 6.13401 16.5 10 16.5Z",
    fill: "#00A5B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46924 12.9828L5.54483 13.8204C5.54483 14.6521 7.53992 15.3252 10 15.3252C12.4601 15.3252 14.4552 14.6509 14.4552 13.8204L14.5308 12.9828C13.6443 13.5199 11.9481 13.8819 10 13.8819C8.05186 13.8819 6.35569 13.5187 5.46924 12.9828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4C7.13449 4 4.81299 4.78436 4.81299 5.75326C4.81299 5.78757 4.81642 5.8207 4.82215 5.85382L5.32264 11.3715L5.46924 12.984C6.35569 13.5211 8.05186 13.8831 10 13.8831C11.9481 13.8831 13.6443 13.5199 14.5308 12.984L14.6774 11.3715L15.1778 5.85382C15.1836 5.8207 15.187 5.78639 15.187 5.75326C15.187 4.78436 12.8655 4 10 4Z",
    fill: "#00A5B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_1002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 12.5,
    fill: "white",
    transform: "translate(3 4)"
  })))));
};
export default SvgHeadMini;